'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from 'angular';
import TaxesController from './controller/taxes';
import TaxSelectController from './controller/taxSelect';
import TaxModalCreateController from './controller/taxModalCreate';
import TaxModalSelectController from './controller/taxModalSelect';
import TaxTableDirective from './directive/taxTable';
import TaxService from './service/tax';

export default angular.module('investmentProject.tax', [])
    .controller('TaxesController', TaxesController)
    .controller('TaxModalCreateController', TaxModalCreateController)
    .controller('TaxModalSelectController', TaxModalSelectController)
    .controller('TaxSelectController', TaxSelectController)
    .directive('taxTable', TaxTableDirective)
    .factory('TaxService', TaxService)
    .name;
